<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Procedimentos</div>
            </div>
            <hr style="margin-top: -4px" />

            <div class="col-md-12">
              <form @submit.prevent>
                <!-- Nome -->
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="Name">
                      <span class="required">*</span> Nome:
                    </label>
                    <input type="text" id="Name" class="form-control" v-model="procedure.title" />
                  </div>
                </div>

                <!-- Descrição -->
                <div class="form-group">
                  <label for="description">
                    <span class="required">*</span> Descrição:
                  </label>
                  <ckeditor v-model="procedure.description" :editor="editor" :config="editorConfig" />
                </div>

                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>

                <!-- Botões -->
                <div class="block text-right mb-1">
                  <!-- Botão de anexo -->
                 <button type="button" class="btn btn-attachment mr-1" @click="openFile">
                Anexar <span class="clip-icon">📎</span>
                 </button>

                  <input type="file" ref="fileInput" style="display:none" @change="handleFile" />

                  <!-- Arquivo existente ou selecionado -->
                  <div v-if="attachedFile" class="attached-file">
                  <button type="button" class="btn btn-attachment mr-1" @click="openFile">
                  </button>

                    <a :href="fileURL" target="_blank">{{ attachedFile.name }}</a>
                  </div>

                  <router-link to="/procedures" class="btn btn-back ml-2">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>

                  <button type="button" class="btn btn-add ml-1" @click="save">
                    Enviar
                    <i class="fa fa-paper-plane"></i>
                  </button>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";

/* UPLOAD ADAPTER CKEDITOR */
class MyUploadAdapter {
  constructor(loader) { this.loader = loader; }
  upload() {
    return this.loader.file.then(
      file => new Promise((resolve, reject) => {
        this._initRequest();
        this._initListeners(resolve, reject, file);
        this._sendRequest(file);
      })
    );
  }
  abort() { if (this.xhr) this.xhr.abort(); }
  _initRequest() {
    this.xhr = new XMLHttpRequest();
    this.xhr.open("POST", "https://api.intranet-dev.it4d.com.br/api/v1/images/upload", true);
    this.xhr.responseType = "json";
  }
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;
    const genericErrorText = `Couldn't upload file: ${file.name}.`;
    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;
      if (!response || response.error) {
        return reject(response && response.error ? response.error.message : genericErrorText);
      }
      resolve({ default: response.url });
    });
    if (xhr.upload) {
      xhr.upload.addEventListener("progress", evt => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }
  _sendRequest(file) {
    const data = new FormData();
    data.append("upload", file);
    this.xhr.send(data);
  }
}

function MyUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = loader => new MyUploadAdapter(loader);
}

export default {
  name: "AddEditProcedure",
  data() {
    return {
      procedure: { title: "", description: "", id: null },
      editor: ClassicEditor,
      editorConfig: { extraPlugins: [MyUploadAdapterPlugin], height: "400px" },
      attachedFile: null,
      fileURL: null
    };
  },
  methods: {
    save() {
      const self = this;
      let api = self.$store.state.api + "procedures";
      const formData = new FormData();

      formData.append("title", self.procedure.title);
      formData.append("description", self.procedure.description);

      // Inclui arquivo real
      if (self.attachedFile && self.attachedFile.fileObj) {
        formData.append("file", self.attachedFile.fileObj);
      }

      // Se for edição
      if (self.procedure.id) {
        api += "/" + self.procedure.id;
        formData.append("_method", "PUT");
      }

      // Axios com multipart/form-data
      axios.post(api, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          self.$message("Sucesso", "Informações guardadas com sucesso", "success");
          this.$router.push("/procedures");
        })
        .catch(error => {
          console.error("❌ Erro ao salvar procedimento:", error.response?.data);
          self.$message(null, error.response?.data?.message || "Erro ao enviar", "error");
        });
    },
    getProcedures(id) {
      const api = this.$store.state.api + "procedures/" + id;

      axios.get(api)
        .then(res => {
          const data = res.data.data[0];
          this.procedure = data;


          if (data.file) {
            this.attachedFile = {
              name: data.file.split('/').pop(),
              fileObj: null
            };

            // URL para visualização via rota de download (agora pública)
            this.fileURL = `${this.$store.state.api}procedures/${this.procedure.id}/download`;

          }
        })
        .catch(error => {
          console.error("Erro ao buscar procedimento:", error.response);
          this.$message(null, error.response?.data || "Erro ao buscar", "error");
        });
    },
    openFile() {
      this.$refs.fileInput.click();
    },
    handleFile(event) {
      const file = event.target.files[0];
      if (file) {
        this.attachedFile = {
          name: file.name,
          fileObj: file // objeto real para envio
        };
        this.fileURL = URL.createObjectURL(file);
      }
    }
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) this.getProcedures(id);
  },
  components: { BaseCrud, vSelect }
};
</script>

<style scoped>
.btn-attachment {
  background-color: #fff;
  color: #6E6B7B;
  border: 1px solid #6E6B7B;
  padding: 6px 12px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.btn-attachment i {
  margin: 0;
  font-size: 16px;
}

.btn-attachment:hover {
  background-color: #f0f0f0;
}

.attached-file {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: #6E6B7B;
  margin-left: 10px;
}

.attached-file i {
  margin-right: 6px;
}

.attached-file a {
  text-decoration: underline;
  color: #6E6B7B;
}
</style>
